import PropTypes from 'prop-types';
import React from 'react';
import { Select } from 'components/FormFields';
import { SegmentedFilter, useIsMobile } from 'components/v3';
import { TopicFiltersWrapper } from '../StyledComponents';

const TopicFiltersContainer = ({ topics, activeTopic, onSelectTopic }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    const options = [
      { label: 'All Topics', value: '' },
      ...(topics || []).map((topic) => ({
        label: topic.name,
        value: topic.id,
      })),
    ];

    return (
      <TopicFiltersWrapper>
        <Select
          value={activeTopic || ''}
          onChange={(e) => onSelectTopic(e.target.value || null)}
          options={options}
        />
      </TopicFiltersWrapper>
    );
  }

  return (
    <TopicFiltersWrapper>
      <SegmentedFilter
        value={activeTopic || ''}
        onChange={(key) => onSelectTopic(key || null)}
        options={[
          { key: '', label: 'All Topics' },
          ...(topics || []).map((topic) => ({
            key: topic.id,
            label: topic.name,
          })),
        ]}
      />
    </TopicFiltersWrapper>
  );
};

TopicFiltersContainer.propTypes = {
  topics: PropTypes.array,
  activeTopic: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelectTopic: PropTypes.func,
};

export default TopicFiltersContainer;
